import { render, staticRenderFns } from "./PdfIndex2.vue?vue&type=template&id=24b0bf20&scoped=true"
import script from "./PdfIndex2.vue?vue&type=script&lang=js"
export * from "./PdfIndex2.vue?vue&type=script&lang=js"
import style0 from "./PdfIndex2.vue?vue&type=style&index=0&id=24b0bf20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b0bf20",
  null
  
)

export default component.exports